import React from 'react';
import ImageWithActions from '../../../../pages/discovery/components/Report/components/ReportListItem/components/ImageWithActions';
import TranslationHelper from '../../../../helpers/TranslationHelper';
import { IBinaryValue, IReportEntity } from '../../../../state/types';
import { hasQueryParams } from '../../../../helpers/hasQueryParams';
import Image from '../../../../components/Image';
import { ListItem } from '@material-ui/core';

export const renderImageWithActionsComponent = (
    entity: IReportEntity,
    url: string,
    downloadUrl: string,
    classes: any,
    reportId: string
) => {
    return (
        <ListItem className={classes.listItem}>
            <ImageWithActions
                classes={classes}
                apiPreview={url}
                apiDownload={downloadUrl}
                name={`${TranslationHelper.translate(
                    entity.label as string,
                    'mp'
                )} (${entity.label})`}
                download={
                    (entity.value as IBinaryValue)?.name ||
                    (entity.value as string)
                }
                valid={!!url}
                type={entity.type}
                paramName={entity.id}
                reportId={reportId}
            />
        </ListItem>
    );
};

export const renderImageComponent = (
    entity: IReportEntity,
    classes: any,
    privileges: any
) => {
    const action = entity.actions?.preview;
    if (!action) return null;

    const anonymizeQueryParam = hasQueryParams(action?.api || '')
        ? '&anonymize='
        : '?anonymize=';

    const imageUrl = `${action?.api}${anonymizeQueryParam}${privileges.anonymize}`;

    return (
        <ListItem className={classes.listItem}>
            <div className={classes.photoContainer}>
                <Image
                    apiDownload={imageUrl}
                    imageUrl={imageUrl}
                    name={`${TranslationHelper.translate(
                        entity.label as string,
                        'mp'
                    )} (${entity.label})`}
                    valid={!!imageUrl}
                    download={
                        (entity.value as IBinaryValue)?.name ||
                        (entity.value as string)
                    }
                    paramName={entity.id}
                />
            </div>
        </ListItem>
    );
};
